
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/for-professionals",
      function () {
        return require("private-next-pages/en/for-professionals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/for-professionals"])
      });
    }
  